import { Badge, Box, IconButton, Tooltip } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";

interface Props {
    formType: string;
    formId: string;
    draft: any;
    onRestore: () => void;
    countdown?: number; // Add countdown prop
  }
  
  // In the component
  export default function DraftRestoreButton({ onRestore, countdown }: Props) {
    // The component only uses onRestore and countdown, other props are passed for consistency
    
    return (
      <Box sx={{ position: 'fixed', right: 20, top: 120, zIndex: 1100 }}>
        <Tooltip
          title={countdown && countdown > 0 
            ? `Przywróć wersję roboczą (usunie się za ${countdown}s)` 
            : "Przywróć wersję roboczą"}
          placement="left"
        >
          <IconButton
            onClick={onRestore}
            color="secondary"
            sx={{
              backgroundColor: 'background.paper',
              boxShadow: 3,
              border: '2px solid',
              borderColor: 'secondary.main',
              '&:hover': {
                backgroundColor: 'secondary.light',
              }
            }}
          >
            <Badge
              badgeContent={countdown && countdown > 0 ? countdown : null}
              color="error"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <RestoreIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
    );
  }